/* BlueCart 2 theme JS — vanilla, deferred, no dependencies. */
(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  const formatMoney = (cents) => {
    const fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    const n = (cents / 100);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  };

  /* ---------------- Mega menu ---------------- */
  function initMegaMenu() {
    const items = $$('.nav-item[data-mega]');
    let openTimer, closeTimer;
    const closeAll = (except) => items.forEach((i) => {
      if (i !== except) { i.classList.remove('is-open'); const a = i.querySelector(':scope > a'); a && a.setAttribute('aria-expanded', 'false'); }
    });
    const open = (item) => { closeAll(item); item.classList.add('is-open'); item.querySelector(':scope > a').setAttribute('aria-expanded', 'true'); };
    items.forEach((item) => {
      const trigger = item.querySelector(':scope > a');
      item.addEventListener('mouseenter', () => { clearTimeout(closeTimer); openTimer = setTimeout(() => open(item), 120); });
      item.addEventListener('mouseleave', () => { clearTimeout(openTimer); closeTimer = setTimeout(() => closeAll(), 180); });
      item.addEventListener('focusin', () => open(item));
      item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) item.classList.remove('is-open'); });
      // Touch devices: first tap opens, second tap follows the link.
      trigger.addEventListener('click', (e) => {
        if (window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) { e.preventDefault(); open(item); }
      });
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
  }

  /* ---------------- Drawer with drill-down ---------------- */
  function initDrawer() {
    const drawer = $('#MenuDrawer');
    if (!drawer) return;
    let lastFocus;
    const panels = () => $$('.drill', drawer);
    const show = (id) => {
      panels().forEach((p) => {
        if (p.id === id) { p.setAttribute('aria-hidden', 'false'); p.classList.remove('is-behind'); }
        else if (p.getAttribute('aria-hidden') === 'false') { p.setAttribute('aria-hidden', 'true'); p.classList.add('is-behind'); }
      });
      const target = document.getElementById(id);
      const f = target && target.querySelector('button, a');
      f && f.focus({ preventScroll: true });
    };
    const reset = () => panels().forEach((p) => { const root = p.dataset.root === 'true'; p.setAttribute('aria-hidden', root ? 'false' : 'true'); p.classList.remove('is-behind'); });
    const openDrawer = () => {
      lastFocus = document.activeElement; reset();
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('has-drawer');
      setTimeout(() => { const c = $('.drawer__close', drawer); c && c.focus(); }, 50);
    };
    const closeDrawer = () => {
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('has-drawer');
      lastFocus && lastFocus.focus();
    };
    $$('[data-drawer-open]').forEach((b) => b.addEventListener('click', openDrawer));
    $$('[data-drawer-close]', drawer).forEach((b) => b.addEventListener('click', closeDrawer));
    drawer.addEventListener('click', (e) => {
      const next = e.target.closest('[data-drill-to]');
      if (next) { e.preventDefault(); show(next.dataset.drillTo); }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
  }

  /* ---------------- Predictive search ---------------- */
  function initSearch() {
    $$('[data-global-search]').forEach((root) => {
      const form = $('form', root);
      const input = $('input[type="search"]', root);
      const select = $('select[data-search-category]', root);
      const results = $('.predictive', root);
      if (!form || !input) return;

      // Category scoping: append "tag:<handle>" to the query on submit.
      form.addEventListener('submit', (e) => {
        const term = input.value.trim();
        const cat = select && select.value;
        if (!term && !cat) { e.preventDefault(); input.focus(); return; }
        if (cat) { e.preventDefault(); location.href = `${form.action}?type=product&options[prefix]=last&q=${encodeURIComponent(`${term} tag:${cat}`.trim())}`; }
      });

      if (!results || root.dataset.predictive !== 'true') return;
      let controller; let activeIdx = -1;
      const close = () => { results.hidden = true; input.setAttribute('aria-expanded', 'false'); activeIdx = -1; };
      const options = () => $$('.predictive__item, .predictive__all', results);
      const highlight = (i) => {
        const opts = options(); if (!opts.length) return;
        activeIdx = (i + opts.length) % opts.length;
        opts.forEach((o, n) => o.setAttribute('aria-selected', n === activeIdx ? 'true' : 'false'));
        opts[activeIdx].scrollIntoView({ block: 'nearest' });
      };
      const fetchResults = debounce(async (term) => {
        if (term.length < 2) { close(); return; }
        controller && controller.abort();
        controller = new AbortController();
        try {
          const url = `${window.theme.routes.predictiveSearch}?q=${encodeURIComponent(term)}&section_id=predictive-search&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last`;
          const res = await fetch(url, { signal: controller.signal });
          if (!res.ok) throw new Error(res.status);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('#predictive-search-results');
          results.innerHTML = inner ? inner.innerHTML : '';
          results.hidden = !inner || !inner.innerHTML.trim();
          input.setAttribute('aria-expanded', String(!results.hidden));
          activeIdx = -1;
        } catch (err) { if (err.name !== 'AbortError') close(); }
      }, 180);

      input.addEventListener('input', () => fetchResults(input.value.trim()));
      input.addEventListener('focus', () => { if (results.innerHTML.trim() && input.value.trim().length > 1) { results.hidden = false; } });
      input.addEventListener('keydown', (e) => {
        if (results.hidden) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); highlight(activeIdx + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(activeIdx - 1); }
        else if (e.key === 'Enter' && activeIdx > -1) { e.preventDefault(); options()[activeIdx].click(); }
        else if (e.key === 'Escape') { close(); }
      });
      document.addEventListener('click', (e) => { if (!root.contains(e.target)) close(); });
    });
  }

  /* ---------------- Hero slideshow ---------------- */
  function initHero() {
    $$('[data-hero]').forEach((hero) => {
      const track = $('.hero__track', hero);
      const slides = $$('.hero__slide', hero);
      const dots = $$('.hero__dot', hero);
      if (slides.length < 2) return;
      let index = 0; let timer;
      const go = (i) => { index = (i + slides.length) % slides.length; track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' }); };
      const sync = () => {
        const i = Math.round(track.scrollLeft / track.clientWidth); index = i;
        dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
      };
      track.addEventListener('scroll', debounce(sync, 60), { passive: true });
      dots.forEach((d, n) => d.addEventListener('click', () => go(n)));
      $('.hero__arrow--prev', hero)?.addEventListener('click', () => go(index - 1));
      $('.hero__arrow--next', hero)?.addEventListener('click', () => go(index + 1));
      const speed = parseInt(hero.dataset.autoplay || '0', 10) * 1000;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (speed && !reduce) {
        const start = () => { stop(); timer = setInterval(() => go(index + 1), speed); };
        const stop = () => clearInterval(timer);
        hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', start);
        hero.addEventListener('focusin', stop); hero.addEventListener('focusout', start);
        document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
        start();
      }
    });
  }

  /* ---------------- Product rails ---------------- */
  function initRails() {
    $$('.rail-wrap:not([data-rail-ready])').forEach((wrap) => {
      wrap.dataset.railReady = 'true';
      const rail = $('.rail', wrap);
      const step = () => rail.clientWidth * 0.9;
      $('.rail-arrow--prev', wrap)?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
      $('.rail-arrow--next', wrap)?.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  }

  /* ---------------- Tabs ---------------- */
  function initTabs() {
    $$('[data-tabs]').forEach((root) => {
      const tabs = $$('[role="tab"]', root);
      const select = (tab) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t));
        t.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
            select(n); n.focus();
          }
        });
      });
    });
  }

  /* ---------------- Cart ---------------- */
  const toast = (html) => {
    const el = $('#CartToast'); if (!el) return;
    el.innerHTML = html; el.hidden = false;
    clearTimeout(el._t); el._t = setTimeout(() => { el.hidden = true; }, 4000);
  };
  const updateCount = (count) => $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.dataset.count = count; });

  async function addToCart(form, button) {
    button.classList.add('is-loading');
    try {
      const res = await fetch(`${window.theme.routes.cartAdd}.js`, {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      const cart = await (await fetch(`${window.theme.routes.cart}.js`)).json();
      updateCount(cart.item_count);
      toast(`<span>Added <strong>${(data.product_title || '').replace(/</g, '&lt;')}</strong></span><a href="${window.theme.routes.cart}">View cart</a>`);
    } catch (err) {
      toast(`<span>${String(err.message).replace(/</g, '&lt;')}</span>`);
    } finally { button.classList.remove('is-loading'); }
  }

  function initAddToCart() {
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form[data-ajax-cart]');
      if (!form) return;
      e.preventDefault();
      addToCart(form, form.querySelector('[type="submit"]'));
    });
  }

  function initCartPage() {
    const form = $('#CartForm'); if (!form) return;
    form.addEventListener('change', debounce((e) => { if (e.target.matches('input[name="updates[]"]')) form.submit(); }, 400));
  }

  /* ---------------- Quantity steppers ---------------- */
  function initQty() {
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-qty]'); if (!b) return;
      const input = b.parentElement.querySelector('input');
      const v = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qty, 10));
      input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------------- Collection filters (Section Rendering API) ---------------- */
  function initFilters() {
    const root = $('[data-collection]'); if (!root) return;
    const sectionId = root.dataset.sectionId;
    const render = async (url, push = true) => {
      root.classList.add('is-loading');
      const u = new URL(url, location.origin);
      u.searchParams.set('section_id', sectionId);
      try {
        const html = await (await fetch(u)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        ['#ProductGrid', '#FiltersForm', '#ActiveFilters', '#ProductCount'].forEach((sel) => {
          const src = doc.querySelector(sel); const dst = $(sel, root);
          if (src && dst) dst.innerHTML = src.innerHTML;
        });
        u.searchParams.delete('section_id');
        if (push) history.pushState({ filters: true }, '', u.toString());
      } catch { location.href = url; }
      root.classList.remove('is-loading');
    };
    const fromForm = () => {
      const form = $('#FiltersForm', root);
      const params = new URLSearchParams(new FormData(form));
      const sort = $('#SortBy', root);
      if (sort) params.set('sort_by', sort.value);
      for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
      return `${location.pathname}?${params.toString()}`;
    };
    const onChange = debounce(() => render(fromForm()), 350);
    root.addEventListener('change', (e) => { if (e.target.closest('#FiltersForm') || e.target.id === 'SortBy') onChange(); });
    root.addEventListener('click', (e) => {
      const a = e.target.closest('[data-filter-link]');
      if (a) { e.preventDefault(); render(a.href); }
      if (e.target.closest('[data-filters-open]')) $('.filters', root).classList.add('is-open');
      if (e.target.closest('[data-filters-close]')) $('.filters', root).classList.remove('is-open');
    });
    window.addEventListener('popstate', (e) => { if (e.state && e.state.filters) render(location.href, false); });
  }

  /* ---------------- Shipping estimate ---------------- */
  // "3-7" → { min: 3, max: 7 }; a single number works too.
  const parseDays = (s) => {
    const m = String(s || '').match(/(\d+)\s*(?:[-–to]+\s*(\d+))?/);
    if (!m) return null;
    const min = parseInt(m[1], 10); const max = m[2] ? parseInt(m[2], 10) : min;
    return { min: Math.min(min, max), max: Math.max(min, max) };
  };
  const addBusinessDays = (date, n) => {
    const d = new Date(date);
    let left = n;
    while (left > 0) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) left -= 1; }
    return d;
  };
  const fmtDate = (d) => d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
  const escapeHtml = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function renderShipBox(box, ship, notes) {
    if (!box) return;
    if (!ship || !ship.type) { box.hidden = true; return; }
    box.hidden = false;
    box.className = `ship-box ship-box--${ship.type}`;
    const tagWrap = box.querySelector('[data-ship-tag]');
    const days = parseDays(ship.days);
    if (tagWrap) {
      const daysTxt = days ? `${days.min}${days.max !== days.min ? `–${days.max}` : ''} days` : '';
      tagWrap.innerHTML = `<span class="ship-tag ship-tag--${ship.type}"><span class="ship-tag__label">${escapeHtml(ship.label)}</span>${daysTxt ? `<span class="ship-tag__days">${daysTxt}</span>` : ''}</span>`;
    }
    const eta = box.querySelector('[data-ship-eta-wrap]');
    if (eta) {
      if (days) {
        const processing = parseInt(box.dataset.processing || '0', 10) || 0;
        const today = new Date();
        const from = addBusinessDays(today, processing + days.min);
        const to = addBusinessDays(today, processing + days.max);
        eta.hidden = false;
        eta.innerHTML = `Estimated arrival <strong>${fmtDate(from)}${days.max !== days.min ? ` – ${fmtDate(to)}` : ''}</strong>`;
      } else { eta.hidden = true; }
    }
    const note = box.querySelector('[data-ship-note]');
    if (note) {
      const text = notes && notes[ship.type];
      note.textContent = text || ''; note.hidden = !text;
    }
  }

  /* ---------------- Product page ---------------- */
  function initProduct() {
    $$('[data-product]').forEach((root) => {
      const json = $('script[data-product-json]', root);
      if (!json) return;
      const product = JSON.parse(json.textContent);
      const idInput = $('input[name="id"]', root);
      const btn = $('[data-add-button]', root);
      const priceEl = $('[data-price]', root);
      const stockEl = $('[data-stock]', root);
      const mainImg = $('.pdp-gallery__main img', root);
      const shipBox = $('[data-ship-box]', root);
      const current = product.variants.find((v) => String(v.id) === String(idInput && idInput.value)) || product.variants[0];
      if (current) renderShipBox(shipBox, current.ship, product.shipNotes);

      // Gallery thumbs
      $$('.pdp-gallery__thumb', root).forEach((t) => t.addEventListener('click', () => {
        $$('.pdp-gallery__thumb', root).forEach((x) => x.setAttribute('aria-current', 'false'));
        t.setAttribute('aria-current', 'true');
        if (mainImg) { mainImg.src = t.dataset.full; mainImg.srcset = ''; mainImg.alt = t.querySelector('img')?.alt || ''; }
      }));

      root.addEventListener('change', (e) => {
        const fieldset = e.target.closest('.option');
        if (!fieldset) return;
        const label = $('[data-option-value]', fieldset);
        if (label && e.target.value) label.textContent = e.target.value;
        const selected = $$('.option', root).map((fs) => ($('input:checked', fs) || {}).value);
        const variant = product.variants.find((v) => v.options.every((o, i) => o === selected[i]));
        if (!variant) {
          btn.disabled = true; btn.textContent = 'Unavailable'; return;
        }
        idInput.value = variant.id;
        renderShipBox(shipBox, variant.ship, product.shipNotes);
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? 'Add to cart' : 'Sold out';
        if (priceEl) {
          const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
          priceEl.className = `price${sale ? ' price--sale' : ''}`;
          priceEl.innerHTML = `<span class="price__now">${formatMoney(variant.price)}</span>${sale ? `<s class="price__was">${formatMoney(variant.compare_at_price)}</s><span class="price__save">Save ${Math.round((1 - variant.price / variant.compare_at_price) * 100)}%</span>` : ''}`;
        }
        if (stockEl) { stockEl.textContent = variant.available ? 'In stock' : 'Out of stock'; stockEl.classList.toggle('buybox__stock--out', !variant.available); }
        if (variant.featured_image && mainImg) { mainImg.src = variant.featured_image.src; mainImg.srcset = ''; }
        const url = new URL(location.href); url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      });
    });
  }

  /* ---------------- Lazy product recommendations ---------------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach((el) => {
      const load = async () => {
        try {
          const html = await (await fetch(el.dataset.url)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initRails(); }
        } catch { /* recommendations are optional */ }
      };
      if (!('IntersectionObserver' in window)) { load(); return; }
      const io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { io.disconnect(); load(); }
      }, { rootMargin: '400px 0px' });
      io.observe(el);
    });
  }

  const init = () => {
    initMegaMenu(); initDrawer(); initSearch(); initHero(); initRails(); initTabs();
    initAddToCart(); initCartPage(); initQty(); initFilters(); initProduct(); initRecommendations();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
